module.exports = __webpack_public_path__ + "static/img/ic_link.d999ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_link.png
// module id = YJo/
// module chunks = 1